import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { injectIntl } from 'react-intl';
import history from '../../../../../../services/history';
import moment from 'moment';
import { grey400, grey800 } from 'material-ui/styles/colors';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import HideIfPrint from '../../../../../../components/HideIfPrint';
import EditIconButton from '../../../../../../components/EditIconButton';
import DeleteIconButton from '../../../../../../components/DeleteIconButton';
import QuestionPicker from '../../../../../../components/QuestionPicker';
import CopyWidgetsDialog from './components/CopyWidgetsDialog';
import ReportFilters from './components/ReportFilters';
import EditReportDialog from './components/EditReportDialog';
import ArchiveReportMutation from '../../../../../../mutations/ArchiveReportMutation';
import JobStatusMutation from '../../../../../../mutations/JobStatusMutation';
import CreateJobPdfExportMutation from '../../../../../../mutations/CreateJobPdfExportMutation';
import PopulateReportMutation from '../../../../../../mutations/PopulateReportMutation';
import CreateReportQuestionFilterMutation from '../../../../../../mutations/CreateReportQuestionFilterMutation';
import Toggle from 'material-ui/Toggle';
import withQueryStringProps from '../../../../../../components/withQueryStringProps';
import queryStringParams from '../../../../../../services/queryStringParams';
import getTranslatedText from '../../../../../../services/getTranslatedText';



const styles = {
  titleWrapper: {
    display: 'inline-block',
    margin: '24px 0 22px',
    width: '80%',
  },
  title: {
    color: grey800,
    display: 'inline-block',
    fontSize: '35px',
    fontWeight: 900,
    margin: 0,
    maxWidth: '93%',
  },
  rightButtonsWrapper: {
    display: 'inline-block',
    textAlign: 'right',
    width: '20%',
  },
  exportButton: {
    verticalAlign: 'text-bottom',
    marginTop: 10,
    fontSize: '16px',
  },
  exportButtonLabel: {
    textTransform: 'none',
    fontSize: '16px',
  },
  populateReportButton: {
    verticalAlign: 'text-bottom',
  },
  populateReportButtonLabel: {
    textTransform: 'none',
    fontSize: '16px',
  },
  copyWidgetsButton: {
    verticalAlign: 'text-bottom',
    marginBottom: '10px',
  },
  copyWidgetsButtonLabel: {
    textTransform: 'none',
    fontSize: '16px',
  },
  demo: {
    marginBottom: '8px',
  }
};
@withQueryStringProps(['demo', 'to', 'from', 'selectedTags', 'questionFilters'])
@injectIntl
class ReportHeader extends Component {
  constructor(props) {
    super(props);

    let questionFilters = [];

    if (Array.isArray(this.props.questionFilters) && this.props.questionFilters.length) {
      questionFilters = this.props.questionFilters || [];
    } else {
      questionFilters = queryStringParams.get('questionFilters') || [];
    }

    const qsObj = queryStringParams.get('devices');

    this.state = {
      editReportDialogOpen: false,
      deleteReportConfirmationOpen: false,
      exportPdfLoading: false,
      populateReportLoading: false,
      copyWidgetsLoading: false,
      copyWidgetsDialogOpen: false,
      populateReportSurveySelectorOpen: false,
      populateReportAnchorEl: null,
      showReportFilters: true,
      demo: !!this.props.demo,
      to: this.props.to,
      from: this.props.from,
      paramDevices: qsObj || [],
      selectedTags: this.props.selectedTags || [],
      questionFilters,
    };
  }

  showEditReportDialog = () => {
    this.setState({ editReportDialogOpen: true });
  };

  hideEditReportDialog = () => {
    this.setState({ editReportDialogOpen: false });
  };

  showDeleteReportConfirmation = () => {
    this.setState({ deleteReportConfirmationOpen: true });
  };

  hideDeleteReportConfirmation = () => {
    this.setState({ deleteReportConfirmationOpen: false });
  };

  deleteReport = () => {
    this.setState({ deleteReportConfirmationOpen: false });
    ArchiveReportMutation.commit(
      {
        reportId: this.props.report.id,
      },
      (err, url) => {
        if (err) {
          alert(err);
        } else {
          history.replace('/');
        }
      },
    );
  };



  /**
   * 
   */
  exportPdf = async () => {


    this.setState({ exportPdfLoading: true });

    const filename =
      this.props.viewer.accountName + ' - ' +
      this.props.report.name + ' - ' +
      moment().format('YYYY-MM-DD') +
      '.pdf';

    const reportId = this.props.report.mongoId;

    let createdJob;
    try {
      createdJob = await this.createJob(reportId);
    } catch (error) {
      this.setState({ exportPdfLoading: false });
      console.log(`ERROR creating a job: ${error.message}`);
    }

    let job;
    try {
      job = await this.jobStatus(createdJob.jobId, reportId);
    } catch (error) {
      this.setState({ exportPdfLoading: false });
      console.log(`ERROR checking job status: ${error.message}`);
    }

    const jobFilename = encodeURIComponent(job.filename).replace(/%20/g, '+');
    const url = `${process.env.REACT_APP_TNT_EXPORTS_URL}/${jobFilename}`;

    try {
      this.saveFile(url, filename);
    } catch (error) {
      console.log(`ERROR saving a file: ${error.message}`);
    }
    this.setState({ exportPdfLoading: false });

  };



  /**
   * 
   * @param {*} reportId 
   * @returns 
   */
  saveFile = (url, filename) => {
    const downloadLink = document.createElement('a');
    downloadLink.download = filename;
    downloadLink.href = url;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }



  /**
   * Job status
   */
  createJob = async (reportId) => {
    const filename =
      this.props.viewer.accountName + ' - ' +
      this.props.report.name + ' - ' +
      moment().format('YYYY-MM-DD') +
      '.pdf';

    let from = moment().subtract(90, 'days').format('YYYY-MM-DD');
    let to = moment().format('YYYY-MM-DD');
    let devices = [];
    let selectedTags = [];
    let questionFilters = queryStringParams.get('questionFilters') || [];

    if (this.state.from) {
      from = this.state.from;
    }

    if (this.state.to) {
      to = this.state.to;
    }

    if (this.state.paramDevices) {
      devices = this.state.paramDevices;
    }

    if (this.state.selectedTags) {
      selectedTags = this.state.selectedTags;
    }

    // if (Array.isArray(this.state.questionFilters) && this.state.questionFilters.length) {
    //   questionFilters = this.state.questionFilters;
    // }

    return new Promise(async (resolve, reject) => {

      CreateJobPdfExportMutation.commit(
        {
          reportId: reportId,
          exportId: '',
          type: 'pdf-export',
          filename,
          from,
          to,
          devices,
          selectedTags,
          questionFilters,
        },
        (err, job) => {
          if (err) {
            return reject(err);
          } else {
            return resolve(job);
          }
        },
      );

    });

  };



  /**
   * Check job status
   */
  jobStatus = async (jobId, reportId) => {

    return new Promise(async (resolve, reject) => {
      JobStatusMutation.commit(
        {
          jobId,
          reportId,
          exportId: '',
          type: 'pdf-export',
        },
        (err, job) => {
          if (err) {
            return reject(err);
          } else {
            if (job.failedReason) {
              return reject(new Error('job.failedReason'));
            }
            if (job.finishedOn) {
              // console.log('finished', job.finishedOn);
              return resolve(job);
            }
            setTimeout(async () => {
              try {
                const j = await this.jobStatus(jobId, reportId);
                return resolve(j);
              } catch (error) {
                return reject(error);
              }
            }, 1000);
          }
        },
      );
    });

  };

  /**
   * Open widgets dialog
   * @param {*} event 
   */
  showCopyWidgetsDialog = () => {
    this.setState({
      copyWidgetsDialogOpen: true,
    });
  };

  /**
   * Close widgets dialog
   * @param {*} event 
   */
  closeCopyWidgetsDialog = () => {
    this.setState({
      copyWidgetsDialogOpen: false,
    });
  };

  showPopulateReportSurveySelector = (event) => {
    this.setState({
      populateReportSurveySelectorOpen: true,
      populateReportAnchorEl: event.currentTarget,
    });
  };

  hidePopulateReportSurveySelector = () => {
    this.setState({
      populateReportSurveySelectorOpen: false,
    });
  };

  populateReport = (surveyId) => {
    this.setState({
      populateReportSurveySelectorOpen: false,
      populateReportLoading: true,
    });
    PopulateReportMutation.commit(
      {
        reportId: this.props.report.id,
        surveyId,
        widgetWidth: 12,
        widgetHeight: 18,
      },
      (err) => {
        if (err) {
          this.setState({ populateReportLoading: false });
          alert(err);
        } else {
          this.setState({ populateReportLoading: false });
        }
      },
    );
  };

  addQuestionFilter = (questionMongoId) => {
    CreateReportQuestionFilterMutation.commit({
      reportId: this.props.report.id,
      questionMongoId: questionMongoId,
    });
  };

  /**
   * Force update other child components after report settings update
   * Reply doen't pick up changes automatically
   */
  onEditDialogSubmit = () => {
    this.setState({ showReportFilters: false });
    setTimeout(() => {
      this.setState({ showReportFilters: true });
    })
  }

  /**
   * Toggle demo mode
   */
  toggleDemoMode = () => {

    if (!this.state.demo) {
      this.props.qs.set({ demo: true });
    } else {
      this.props.qs.set({ demo: null });
    }

    this.setState({ demo: !this.state.demo });
    window.location.replace(window.location.href);
  }

  /**
   * componentWillReceiveProps
   * @param {*} nextProps 
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.to) {
      this.setState({ to: nextProps.to });
    }
    if (nextProps.from) {
      this.setState({ from: nextProps.from });
    }
    if (nextProps.selectedTags) {
      this.setState({ selectedTags: nextProps.selectedTags });
    }
  }

  /**
   * 
   */
  componentDidMount() {
    this.unlisten = history.listen(() => {
      const qsObj = queryStringParams.get('devices');
      if (qsObj) {
        this.setState({ 'paramDevices': qsObj });
      }
    });
  }

  /**
   * 
   */
  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const isAccountAdmin = this.props.viewer.roles.includes('account_admin');

    return (
      <div style={this.props.style}>
        <div>
          <div style={styles.titleWrapper}>
            <h1 style={styles.title}>
              {this.props.report.name}
            </h1>
            {isAccountAdmin && (
              <span>
                <EditIconButton
                  onTouchTap={this.showEditReportDialog}
                  style={{
                    marginLeft: 10,
                    marginTop: -5,
                    padding: '8px 4px',
                    verticalAlign: 'top',
                    width: 26,
                  }}
                />
                <DeleteIconButton
                  onTouchTap={this.showDeleteReportConfirmation}
                  style={{
                    marginTop: -5,
                    padding: '8px 4px',
                    verticalAlign: 'top',
                    width: 26,
                  }}
                />
              </span>
            )}
          </div>
          <HideIfPrint>
            <div style={styles.rightButtonsWrapper}>
              {isAccountAdmin &&
                <Toggle
                  label="Demo mode"
                  labelPosition="left"
                  toggled={this.state.demo}
                  onToggle={this.toggleDemoMode}
                  style={styles.demo}
                />
              }
              {isAccountAdmin &&
                <RaisedButton
                  label={
                    this.state.copyWidgetsLoading
                      ? 'Loading...'
                      : 'Copy widgets'
                  }
                  disabled={this.state.copyWidgetsLoading}
                  onTouchTap={this.showCopyWidgetsDialog}
                  style={styles.copyWidgetsButton}
                  labelStyle={styles.copyWidgetsButtonLabel}
                />
              }
              {isAccountAdmin &&
                <RaisedButton
                  label={
                    this.state.populateReportLoading
                      ? 'Loading...'
                      : 'Auto-populate report'
                  }
                  disabled={this.state.populateReportLoading}
                  onTouchTap={this.showPopulateReportSurveySelector}
                  style={styles.populateReportButton}
                  labelStyle={styles.populateReportButtonLabel}
                />
              }
              {isAccountAdmin &&
                <Popover
                  open={this.state.populateReportSurveySelectorOpen}
                  anchorEl={this.state.populateReportAnchorEl}
                  anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                  targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                  onRequestClose={this.hidePopulateReportSurveySelector}
                >
                  <Menu>
                    <MenuItem primaryText="Select survey:" disabled={true} />
                    <Divider />
                    {this.props.surveys && this.props.surveys.edges.map(survey =>
                      <MenuItem
                        key={survey.node.id}
                        primaryText={getTranslatedText(survey.node.name, this.props.intl.locale)}
                        onClick={() => this.populateReport(survey.node.id)}
                      />
                    )}
                  </Menu>
                </Popover>
              }
              {isAccountAdmin &&
                <QuestionPicker
                  surveys={this.props.surveys}
                  label="Add question filter"
                  wrapperStyles={{ marginTop: 10 }}
                  onChange={this.addQuestionFilter}
                />

              }
              <RaisedButton
                label={
                  this.state.exportPdfLoading ?
                    this.props.intl.formatMessage({ id: 'loading' }) + '...'
                    :
                    this.props.intl.formatMessage({ id: 'exportPdf' })
                }
                disabled={this.state.exportPdfLoading}
                onTouchTap={this.exportPdf}
                icon={<DownloadIcon color={grey400} />}
                style={styles.exportButton}
                labelStyle={styles.exportButtonLabel}
              />
            </div>
          </HideIfPrint>
        </div>
        {this.state.showReportFilters &&
          <ReportFilters
            viewer={this.props.viewer}
            report={this.props.report}
            devices={this.props.devices}
          />}
        <EditReportDialog
          open={this.state.editReportDialogOpen}
          onClose={this.hideEditReportDialog}
          report={this.props.report}
          devices={this.props.devices}
          isAccountAdmin={isAccountAdmin}
          onSubmit={this.onEditDialogSubmit}
        />

        <Dialog
          actions={[
            <FlatButton
              label="Cancel"
              onTouchTap={this.hideDeleteReportConfirmation}
            />,
            <RaisedButton
              label="Delete"
              primary={true}
              onTouchTap={this.deleteReport}
            />,
          ]}
          modal={false}
          open={this.state.deleteReportConfirmationOpen}
          onRequestClose={this.hideDeleteReportConfirmation}
        >
          Are you sure you want to delete this report?
        </Dialog>

        {!!isAccountAdmin &&
          <CopyWidgetsDialog
            open={this.state.copyWidgetsDialogOpen}
            onClose={this.closeCopyWidgetsDialog}
            report={this.props.report}
            reports={this.props.reports}
          ></CopyWidgetsDialog>
        }
      </div>
    );
  }
}

export default createFragmentContainer(
  ReportHeader,
  graphql`
    fragment ReportHeader_viewer on Viewer {
      roles
      accountName
      devices {
        id
        name
      }
      ...ReportFilters_viewer
    }
    fragment ReportHeader_report on Report {
      id
      mongoId
      name
      ...ReportFilters_report
      ...EditReportDialog_report
      ...CopyWidgetsDialog_report
    }
    fragment ReportHeader_devices on DeviceConnection {
      ...ReportFilters_devices
      ...EditReportDialog_devices
    }
    fragment ReportHeader_surveys on SurveyConnection {
      edges {
        node {
          id
          name {
            text
            language
          }
        }
      }
      ...QuestionPicker_surveys
    }
    fragment ReportHeader_reports on ReportConnection {
      ...CopyWidgetsDialog_reports
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/ReportHeader.js